import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';

// material-ui
import { Box, Button, Card, Dialog, Grid, Switch, Typography } from '@mui/material';

// project imports
import { getClasses, getClassesv2, updateClassStatus, deleteClass, pinClass } from 'services/classService';

import moment from 'moment';
import { currencyFormat } from 'helper/NumberFormat';
import TableComponent from 'components/TopCourtComponents/Table/TableComponent';
import { TCLabel } from 'components/TopCourtComponents/Label/TopCourtLabel';

import { useNavigate } from 'react-router';
import { TypeSelectOption } from 'components/TopCourtComponents/Input/DateRangeFilter';
import ClassFilter from './classFilter';
import { useDebounce } from 'use-debounce';

import Delete from '@mui/icons-material/Delete';
import PushPinIcon from '@mui/icons-material/PushPin';
import { Link } from 'react-router-dom';
import { getUrlCourtCode } from 'helper/Court';
import { checkIsSAdmin, isMerchant } from 'helper/Admin';

const initFilter = {
  name: '',
  load: true,
  eventDateType: TypeSelectOption[0],
  eventDateStart: '',
  eventDateEnd: '',
  ageType: TypeSelectOption[0],
  ageMin: '',
  ageMax: '',
  priceType: TypeSelectOption[0],
  priceMax: '',
  priceMin: '',
  user: null,
  page: 0,
  limit: 20
}

function Classes({

}) {

  const [rows, setRows] = useState([])
  const [loading, setLoading] = useState(false)
  const [showDeleteDialog, setShowDeleteDialog] = useState({
    open: false,
    data: null
  })
  const [totalData, setTotalData] = useState(0)
  const [filter, setFilter] = useState(initFilter)
  const navigate = useNavigate()

  const [debouncedFilter] = useDebounce(filter, 500)

  useEffect(() => {
    (async () => {
      if (debouncedFilter.load == true) {
        console.log('ini cek filter', filter)
        loadClasses()
      }
    })()
  }, [debouncedFilter])

  const loadClasses = async () => {
    setLoading(true)
    let { data, error } = await getClassesv2({
      className: filter.name ? filter.name : '',
      eventDateType: filter.eventDateType ? filter.eventDateType.value : '',
      eventDateStart: filter.eventDateStart ? filter.eventDateStart : '',
      eventDateEnd: filter.eventDateEnd ? filter.eventDateEnd : '',
      ageType: filter.ageType ? filter.ageType.value : '',
      ageMin: filter.ageMin ? filter.ageMin : '',
      ageMax: filter.ageMax ? filter.ageMax : '',
      priceType: filter.priceType ? filter.priceType.value : '',
      priceMin: filter.priceMin ? filter.priceMin : '',
      priceMax: filter.priceMax ? filter.priceMax : '',
      user: filter.user ? filter.user.value : '',
      page: filter.page ? filter.page : 0,
      limit: filter.limit ? filter.limit : 0
    })
    setLoading(false)
    if (error) { console.log(error) }
    if (data) {
      console.log(data)
      setRows(data.classes)
      setTotalData(data.totalData)
    }
  }

  const convertHours = (hours) => {
    let hoursEnd = Number(hours.split(":")[0])
    hoursEnd += 1
    hours = hoursEnd < 10 ? `0${hoursEnd}:00` : `${hoursEnd}:00`
    return hours
  }

  const pinClassFunction = async (row) => {
    setLoading(true)
    let { data, error } = await pinClass(row._id)
    loadClasses()
  }

  const updateClassFunction = async (row) => {
    setLoading(true)
    let { data, error } = await updateClassStatus({
      _id: row._id,
      isActive: !row.isActive
    })
    loadClasses()
  }

  const deleteClassFunction = async (row) => {
    setLoading(true)
    let { data, error } = await deleteClass(row._id)
    setShowDeleteDialog(prev => ({
      ...prev,
      open: false,
      data: null
    }))
    loadClasses()
  }

  const valueCustomator = (row) => {
    console.log('row info', row)
    let allowPIN = false
    if (row.dates) {
      if (moment(row.dates[row.dates.length - 1]).format('YYYY-MM-DD') >= moment().format('YYYY-MM-DD')) {
        allowPIN = true
      }
    } else if (row.date) {
      if (moment(row.date).format('YYYY-MM-DD') >= moment().format('YYYY-MM-DD')) {
        allowPIN = true
      }
    }
    return ({
      className: <Link className='span-link' to={`/${getUrlCourtCode()}/classes/edit/${row._id}`}>{row.name}</Link>,
      eventDate: (row.classSchedule && row.classSchedule.startClassDate && row.classSchedule.endClassDate)
        ? <TCLabel>{`${moment(row.classSchedule.startClassDate).format("YYYY/MM/DD")} - ${moment(row.classSchedule.endClassDate).format("YYYY/MM/DD")}`}</TCLabel>
        : <TCLabel>{(row.dates && row.dates.length > 1) ? `${moment(row.dates[0]).format("YYYY/MM/DD")} - ${moment(row.dates[row.dates.length - 1]).format("YYYY/MM/DD")}`
          : moment(row.date).format("YYYY/MM/DD")}</TCLabel>,
      eventHours: <TCLabel>{`${row.hours[0]} - ${convertHours(row.hours[row.hours.length - 1])}`}</TCLabel>,
      maxPlayer: <TCLabel>{`${row.totalParticipant} / ${row.playersCapacity}`}</TCLabel>,
      ageRange: <TCLabel>{(row.minAge && row.maxAge) ? (row.minAge == row.maxAge) ? row.minAge : `${row.minAge} - ${row.maxAge}` : row.minAge ? `⩾ ${row.minAge}` : row.maxAge ? `⩽ ${row.maxAge}` : 'All age'}</TCLabel>,
      fee: <TCLabel>{currencyFormat(row.fee)}</TCLabel>,
      classImg: <img src={row.classImage} width={'auto'} height={50} alt='' />,
      status: <Grid container xs={12} sx={{
        width: 100
      }}>
        {/* <Grid item pt={1} xs style={{
          cursor: (!allowPIN) ? 'not-allowed' : 'pointer'
        }} onClick={() => {
          // check is expired
          if (allowPIN) { pinClassFunction(row) }
        }}>
            <PushPinIcon style={{width: 20, height: 20, color: (row.index || row.index == 0) ? '#2196f3' : !allowPIN ? '#D0D0D0AB' : '#A9A9A9'}}/>
        </Grid> */}
        <Grid item xs>
          <Switch
            // disabled={(row.totalParticipant && row.totalParticipant > 0)} 
            onChange={() => {
              updateClassFunction(row)
            }} checked={row.isActive} />
        </Grid>
        {/* <Grid item pt={1} xs style={{
          cursor: (row.totalParticipant && row.totalParticipant > 0) ? 'not-allowed' : 'pointer'
        }} onClick={() => {
          if (!row.totalParticipant || (row.totalParticipant && row.totalParticipant <= 0)) {
            setShowDeleteDialog({
              open: true,
              data: row
            })
          }
        }}>
            <Delete style={{width: 20, height: 20, color: (row.totalParticipant && row.totalParticipant > 0) ? '#E35480AB' : '#E35480'}}/>
        </Grid> */}
      </Grid>
    })
  }

  const onChangeFilter = (e) => {
    setFilter(prev => ({
      ...prev,
      ...e
    }))
  }

  const onChangePage = (e) => {
    setFilter(prev => ({
      ...prev,
      ...e
    }))
  }

  const clearFilter = () => {
    setFilter(initFilter)
  }

  return (
    <>
      {
        checkIsSAdmin() &&
        <Button sx={{ mb: 2 }} variant="contained" disableElevation onClick={() => {
          navigate(`/${getUrlCourtCode()}/classes/add`)
        }}>Create Class & Event</Button>
      }
      <ClassFilter filter={filter} onChangeFilter={onChangeFilter} clearFilter={clearFilter} />
      <TableComponent
        columns={[
          { label: "Class Name" },
          { label: "Event Date" },
          { label: "Event Hours" },
          { label: "Reg / Max Players" },
          { label: "Age Range" },
          { label: "Fee" },
          { label: "Class Image" },
          { label: " " }
        ]}
        rows={rows}
        valueCustomator={valueCustomator}
        pageChange={(e) => {
          onChangePage({ page: e })
        }}
        loading={loading}
        totalData={totalData}
        page={filter.page}
      />
      <Dialog open={showDeleteDialog.open} onClick={() => {
        setShowDeleteDialog(prev => ({
          ...prev,
          open: false,
          data: null
        }))
      }}>
        <Card>
          <Grid sx={{
            p: 3
          }}>
            <Grid pb={1}>
              <TCLabel>Are you sure want to delete this class / event ?</TCLabel>
            </Grid>
            <Grid container xs={12} spacing={1} pt={1} justifyContent={"right"}>
              <Grid item>
                <Button onClick={() => {
                  setShowDeleteDialog(prev => ({
                    ...prev,
                    open: false,
                    data: null
                  }))
                }}>Cancel</Button>
              </Grid>
              <Grid item>
                <Button variant='contained' style={{
                  backgroundColor: '#E35480'
                }}
                  disabled={loading}
                  onClick={() => {
                    deleteClassFunction(showDeleteDialog.data)
                  }} >{"Delete"}</Button>
              </Grid>
            </Grid>
          </Grid>
        </Card>
      </Dialog>
    </>
  )
}

export default Classes;
